import { FinancialGroup } from '@/app/models/financalGroup';
import { ByCodeResponse } from '@/app/models/projects';
import { useByCodeQuery } from '@/app/services/projectsApi';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import { Box } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import InitialBalanceTable from './InitialBalanceTable';
import NewEditInitialBalance from './NewEditInitialBalance';

interface InitialBalanceProps {
  group: FinancialGroup | undefined;
}

function InitialBalance(props: InitialBalanceProps) {
  const { code } = useParams();
  const { t } = useTranslation(['costTracking', 'common']);

  const { group } = props;

  const [drawerEditHeader, setDrawerEditHeader] = useState(false);

  const { data: totality } = useByCodeQuery(code as string, {
    skip: !code || !group,
  });

  const [selectedHeaderItem, setSelectedHeaderItem] = useState<ByCodeResponse>();

  return (
    <Box>
      <PageTitle title={t('common:general.information')} sx={{ mb: 0 }} />

      <InitialBalanceTable
        setDrawerEdit={setDrawerEditHeader}
        setSelectedHeaderItem={setSelectedHeaderItem}
        data={totality}
      />
      <LateralDrawer open={drawerEditHeader} setOpen={setDrawerEditHeader} position="right" size="bigger">
        <NewEditInitialBalance selectItem={selectedHeaderItem as ByCodeResponse} setDrawerOpen={setDrawerEditHeader} />
      </LateralDrawer>
    </Box>
  );
}

export default InitialBalance;
